import { useEventListener } from './EventListener';
/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function useResize(_ref) {
  var onResize = _ref.onResize,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? window : _ref$scope;
  return useEventListener({
    event: 'resize',
    handler: onResize,
    scope: scope
  });
}
//# sourceMappingURL=Resize.js.map